import { e as r } from "./engine-is-node.js";
var e = function e(_e) {
  try {
    if (r) return Function('return require("' + _e + '")')();
  } catch (r) {}
};
export { e as t };